// @flow

/*
 * Manual verification:
 * 1. Simulate server downtime, confirm reload retries at random 5–15s intervals
 * 2. When server comes back (200), confirm reload fires after random 3–33s delay
 * 3. Confirm multiple tabs reload at different times (not simultaneously)
 */

import { agent } from './api-agent';

const reload = async () => {
  try {
    const response = await agent.head(window.location.href);
    if (response.statusCode === 200) {
      const delay = Math.floor(Math.random() * 30000) + 3000;
      console.log(`Recieved status 200 from webserver, reloading in ${delay}ms.`);
      await new Promise((resolve) => setTimeout(resolve, delay));
      window.location.reload(true);
    } else {
      const delay = Math.floor(Math.random() * 10000) + 5000;
      console.log(`Received status ${response.statusCode} from webserver, retrying in ${delay}ms.`);
      setTimeout(reload, delay);
    }
  } catch (error) {
    const delay = Math.floor(Math.random() * 10000) + 5000;
    console.log(`Error while checking webserver, retrying in ${delay}ms: ${error.status}`);
    setTimeout(reload, delay);
  }
};

export default reload;
